import React, { useState, useEffect } from "react";
import "./EditUserModal.css";
import { useToast } from "../Toast/ToastContainer"; // Import Toast
// Danh sách hạn mức theo yêu cầu
const LIMIT_OPTIONS = [
    5000000,
    10000000,
    20000000,
    50000000,
    100000000,
    200000000,
    999999999
];

export default function EditUserModal({ isOpen, onClose, user, agentCif, agentName, agentId, onSave }) {
    const [form, setForm] = useState({});
    const toast = useToast();
    // 1. Load dữ liệu khi mở Modal
    useEffect(() => {
        if (user) {
            setForm({
                ...user,
                email: user.email || "",
                role: user.role || "VIEWER",

                // --- SỬA: Map đúng 2 trường hạn mức từ API GET ---
                daily_deposit_limit: user.daily_deposit_limit ? parseInt(user.daily_deposit_limit) : 0,
                daily_withdraw_limit: user.daily_withdraw_limit ? parseInt(user.daily_withdraw_limit) : 0,

                // Các trường hiển thị (Readonly)
                cif_number: user.cif_number || user.cif || "",
                full_name: user.full_name || user.customerName || "",
                phone: user.phone || "",
                username: user.username || "",
                status: user.status || "",
                created_by: user.created_by || "",
                branch_created: user.branch_created || user.branch_code || "",
            });
        }
    }, [user, isOpen]);
    useEffect(() => {
        const fetchMissingPhone = async () => {
            // Chỉ gọi khi: Modal mở, có User, có CIF, nhưng Phone đang bị null/rỗng
            if (isOpen && user && user.cif_number && !user.phone) {
                try {
                    const token = localStorage.getItem("access_token");
                    // Gọi lại API lookup customer mà bạn đã dùng ở trang Create
                    // Lưu ý: Đảm bảo agentId được truyền từ cha vào, hoặc lấy từ user.agent_id
                    const targetAgentId = agentId || user.agent_id;

                    const response = await fetch(`https://api.bvb.cybertech.com.vn/api/v1/admin/users/users/lookup/customer?agent_id=${targetAgentId}&customer_cif=${user.cif_number}`, {
                        method: "GET",
                        headers: { "Authorization": `Bearer ${token}` }
                    });

                    if (response.ok) {
                        const data = await response.json();
                        if (data.phone) {
                            console.log("Đã fetch được SĐT bổ sung:", data.phone);
                            // Cập nhật lại form
                            setForm(prev => ({ ...prev, phone: data.phone }));
                        }
                    }
                } catch (error) {
                    console.error("Không thể lấy SĐT từ lookup:", error);
                }
            }
        };

        fetchMissingPhone();
    }, [isOpen, user, agentId]);
    const update = (key, value) => {
        setForm((prev) => ({ ...prev, [key]: value }));
    };
    // --- 3. HÀM GỌI API UPDATE (MỚI) ---
    const handleUpdateUser = async () => {
        try {
            const token = localStorage.getItem("access_token");

            // Payload theo API PUT mới
            const payload = {
                email: form.email,
                role: form.role,
                daily_deposit_limit: parseInt(form.daily_deposit_limit) || 0,
                daily_withdraw_limit: parseInt(form.daily_withdraw_limit) || 0
            };

            const response = await fetch(`https://api.bvb.cybertech.com.vn/api/v1/admin/users/users/${user.id}`, {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const err = await response.json();
                throw new Error(err.detail || "Lỗi khi cập nhật user");
            }

            const result = await response.json(); // API trả về user mới nhất

            toast.success("Cập nhật thông tin user thành công!");

            // Gọi onSave để báo cho cha reload list và đóng modal
            if (onSave) onSave(result);

        } catch (error) {
            console.error(error);
            toast.error(error.message);
        }
    };
    // Helper format tiền tệ hiển thị
    const formatCurrency = (val) => Number(val).toLocaleString('vi-VN') + " VND";

    // Helper map trạng thái sang tiếng Việt
    const getStatusDisplay = (status) => {
        const map = {
            "ACTIVE": "Hoạt động",
            "LOCKED": "Tạm khóa",
            "CLOSED": "Đóng",
            "WAITING_ACTIVATION": "Chờ kích hoạt",
            "PENDING": "Chờ kích hoạt"
        };
        // Nếu status đã là tiếng Việt thì giữ nguyên, nếu không thì map
        return map[status] || status;
    };

    if (!isOpen) return null;

    return (
        <div className="edit-user-modal-overlay" onClick={onClose}>
            <div className="edit-user-modal" onClick={(e) => e.stopPropagation()}>

                {/* HEADER */}
                <div className="edit-user-header">
                    <h2>Chỉnh sửa tài khoản người dùng</h2>
                    <button className="edit-user-close" onClick={onClose}>✕</button>
                </div>

                {/* BODY */}
                <div className="edit-user-body">
                    <div className="edit-user-grid">

                        {/* --- HÀNG 1 --- */}
                        {/* CIF Đại lý (Lấy từ Props truyền vào hoặc từ user nếu có) */}
                        <div className="edit-user-field">
                            <label>CIF Đại lý thanh toán <span className="required">*</span></label>
                            <input
                                type="text"
                                value={agentCif || form.agent_cif || ""}
                                disabled // KHÔNG ĐƯỢC SỬA
                                className="read-only-field"
                                readOnly
                            />
                        </div>

                        {/* Tên Đại lý */}
                        <div className="edit-user-field">
                            <label>Tên Đại lý thanh toán <span className="required">*</span></label>
                            <input
                                type="text"
                                value={agentName || form.agent_name || ""}
                                disabled
                                className="read-only-field"
                                readOnly
                            />
                        </div>

                        {/* --- HÀNG 2 --- */}
                        {/* Mã khách hàng */}
                        <div className="edit-user-field">
                            <label>Mã khách hàng <span className="required">*</span></label>
                            <div className="edit-user-input-icon">
                                <input
                                    type="text"
                                    value={form.cif_number}
                                    disabled // KHÔNG ĐƯỢC SỬA
                                    className="read-only-field"
                                    readOnly
                                />
                                {/* Ẩn icon search hoặc để mờ vì không được tìm lại ở màn hình Edit */}
                                {/* <span className="edit-user-icon-search disabled"></span> */}
                            </div>
                        </div>

                        {/* Tên khách hàng */}
                        <div className="edit-user-field">
                            <label>Tên khách hàng</label>
                            <input
                                type="text"
                                value={form.full_name}
                                disabled
                                className="read-only-field"
                                readOnly
                            />
                        </div>

                        {/* --- HÀNG 3 --- */}
                        {/* Điện thoại */}
                        <div className="edit-user-field">
                            <label>Điện thoại <span className="required">*</span></label>
                            <input
                                type="text"
                                value={form.phone}
                                disabled // KHÔNG ĐƯỢC SỬA
                                className="read-only-field"
                                readOnly
                            />
                        </div>

                        {/* Email (ĐƯỢC SỬA) */}
                        <div className="edit-user-field">
                            <label>Email</label>
                            <input
                                type="email"
                                value={form.email}
                                onChange={(e) => update("email", e.target.value)}
                                placeholder="user@example.com"
                            />
                        </div>

                        {/* --- HÀNG 4 --- */}
                        {/* Username */}
                        <div className="edit-user-field">
                            <label>Username <span className="required">*</span></label>
                            <input
                                type="text"
                                value={form.username}
                                disabled // KHÔNG ĐƯỢC SỬA
                                className="read-only-field"
                                readOnly
                            />
                        </div>

                        {/* Kênh nhận Password (CỐ ĐỊNH) */}
                        <div className="edit-user-field">
                            <label>Kênh nhận user/Password</label>
                            <input
                                type="text"
                                value="Notice (Digimi) và Email"
                                disabled
                                className="read-only-field"
                                readOnly
                            />
                        </div>

                        {/* --- HÀNG 5 --- */}
                        {/* Nhóm quyền (ĐƯỢC SỬA) */}
                        <div className="edit-user-field">
                            <label>Nhóm quyền app Agent <span className="required">*</span></label>
                            <select
                                value={form.role}
                                onChange={(e) => update("role", e.target.value)}
                            >
                                <option value="VIEWER">Viewer</option>
                                <option value="OPERATOR_LV1">Operator nhập</option>
                                <option value="OPERATOR_LV2">Operator đi thẳng</option>
                                <option value="SUPERVISOR">Supervisor</option>
                                <option value="ADMIN">Admin</option>
                            </select>
                        </div>

                        {/* Trạng thái (KHÔNG ĐƯỢC SỬA Ở FORM NÀY - Dùng nút Action bên ngoài) */}
                        <div className="edit-user-field">
                            <label>Trạng thái</label>
                            <input
                                type="text"
                                value={getStatusDisplay(form.status)}
                                disabled
                                className="read-only-field"
                                readOnly
                            />
                        </div>

                        {/* --- HÀNG 6 --- */}
                        {/* Hạn mức nộp (ĐƯỢC SỬA) */}
                        <div className="edit-user-field">
                            <label>Hạn mức nộp trong ngày <span className="required">*</span></label>
                            <select
                                value={parseInt(form.daily_deposit_limit || 0)}
                                onChange={(e) => update("daily_deposit_limit", e.target.value)}
                            >
                                <option value="0">-- Chọn hạn mức --</option>
                                {LIMIT_OPTIONS.map(limit => (
                                    <option key={limit} value={limit}>{formatCurrency(limit)}</option>
                                ))}
                            </select>
                        </div>

                        {/* Hạn mức rút (ĐƯỢC SỬA) */}
                        <div className="edit-user-field">
                            <label>Hạn mức rút trong ngày <span className="required">*</span></label>
                            <select
                                value={parseInt(form.daily_withdraw_limit || 0)}
                                onChange={(e) => update("daily_withdraw_limit", e.target.value)}
                            >
                                <option value="0">-- Chọn hạn mức --</option>
                                {LIMIT_OPTIONS.map(limit => (
                                    <option key={limit} value={limit}>{formatCurrency(limit)}</option>
                                ))}
                            </select>
                        </div>

                        {/* --- HÀNG 7 (Audit Info - READONLY) --- */}
                        <div className="edit-user-field">
                            <label>User tạo</label>
                            <input type="text" value={form.created_by} disabled className="read-only-field" readOnly />
                        </div>

                        <div className="edit-user-field">
                            <label>Tên CBNV</label>
                            {/* Logic hiển thị tên từ User tạo, nếu API ko trả về thì hiển thị tạm placeholder hoặc logic riêng */}
                            <input type="text" value={form.staff_name || "Admin User"} disabled className="read-only-field" readOnly />
                        </div>

                        <div className="edit-user-field">
                            <label>Branch tạo</label>
                            <input type="text" value={form.branch_created} disabled className="read-only-field" readOnly />
                        </div>

                        <div className="edit-user-field">
                            <label>Tên ĐVKD</label>
                            <input type="text" value={form.unit_name || "Hội sở"} disabled className="read-only-field" readOnly />
                        </div>

                    </div>
                </div>

                {/* FOOTER */}
                <div className="edit-user-footer">
                    <button className="edit-user-btn-cancel" onClick={onClose}>
                        Quay về
                    </button>

                    <button className="edit-user-btn-save" onClick={handleUpdateUser}>
                        Lưu
                    </button>
                </div>
            </div>
        </div>
    );
}